module.exports = require("./fr-BF");